import { Suspense, lazy } from "react";

import { Spin } from "antd";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import "./ForceWhiteSearch.css";
import { AuthGuard, notAuth, withAuth } from "./auth/authGuard";
import Layout from "./components/Layout";
import Routers from "./constants/routers";
import { UserProvider } from "./context/UserContext";
import "./App.css";
import { PermissionGuard } from "./auth/privateRoute";

// Not Auth
const LoginPage = notAuth(lazy(() => import("./pages/LoginPage")));
const HealthCheckPage = notAuth(lazy(() => import("./pages/HealthCheck")));
const MaintenancePage = notAuth(lazy(() => import("./pages/MaintenancePage")));

// Auth
// const DashboardPage = withAuth(lazy(() => import("./pages/DashboardPage")));

const ContractsPage = withAuth(lazy(() => import("./pages/ContractsPage")));
const ContractDetailPage = withAuth(lazy(() => import("./pages/ContractsPage/Detail")));
const ContractRenewalsPage = withAuth(lazy(() => import("./pages/ContractRenewalsPage")));

const ApplicationsPage = withAuth(lazy(() => import("./pages/ApplicationsPage")));
const ApplicationDetailPage = withAuth(lazy(() => import("./pages/ApplicationsPage/Detail")));

const ApplicationIntakePage = withAuth(lazy(() => import("./pages/ApplicationIntakePage")));

const AffiliatesPage = withAuth(lazy(() => import("./pages/AffiliatePage")));
const AffiliateFormPage = withAuth(lazy(() => import("./pages/AffiliatePage/Create")));
const AffiliateDetailPage = withAuth(lazy(() => import("./pages/AffiliatePage/Detail")));
const AffiliateInquiryDetailPage = withAuth(lazy(() => import("./pages/AffiliateInquiriesPage/Detail")));
const AffiliateApplicationsPage = withAuth(lazy(() => import("./pages/AffiliateApplicationsPage")));
const AffiliateApplicationDetailPage = withAuth(lazy(() => import("./pages/AffiliateApplicationsPage/Detail")));
const ShopRegistrationApplicationDetailPage = withAuth(
  lazy(() => import("./pages/ShopRegistrationApplicationsPage/Detail"))
);

const VariableCostRegistrationPage = withAuth(lazy(() => import("./pages/VariableCostRegistrationPage")));

const VariableCostApplicationsPage = withAuth(lazy(() => import("./pages/VariableCostApplicationsPage")));
const VariableCostApplicationDetailPage = withAuth(lazy(() => import("./pages/VariableCostApplicationsPage/Detail")));

const DelinquentsPage = withAuth(lazy(() => import("./pages/DelinquentsPage")));
const DelinquentDetailPage = withAuth(lazy(() => import("./pages/DelinquentsPage/Detail")));
const DelinquentsPoppoPage = withAuth(lazy(() => import("./pages/DelinquentsPoppoPage")));

// const EquipmentWarrantyPage = withAuth(lazy(() => import("./pages/EquipmentWarrantyPage")));
// const EquipmentWarrantyDetailPage = withAuth(lazy(() => import("./pages/EquipmentWarrantyDetailPage")));

// const ItanjiIntegrationPage = withAuth(lazy(() => import("./pages/ItanjiIntegrationPage")));
// const CustomersPage = withAuth(lazy(() => import("./pages/CustomersPage")));

const InitialBillingPage = withAuth(lazy(() => import("./pages/InitialBillingPage")));

// const PaymentManagementPage = withAuth(lazy(() => import("./pages/PaymentManagementPage")));

const FinancePage = withAuth(lazy(() => import("./pages/FinancePage")));
const InvoiceManagementPage = withAuth(lazy(() => import("./pages/InvoiceManagementPage")));

const OwnerRemittancePage = withAuth(lazy(() => import("./pages/OwnerRemittancePage")));

// const CommunicationPage = withAuth(lazy(() => import("./pages/CommunicationPage")));
const SettingsPage = withAuth(lazy(() => import("./pages/SettingsPage")));
const SystemSettingsPage = withAuth(lazy(() => import("./pages/SystemSettingsPage")));

const LegacyBuildingsPage = withAuth(lazy(() => import("./pages/BuildingsPage/Legacy")));
const BuildingsPage = withAuth(lazy(() => import("./pages/BuildingsPage")));

const OwnersPage = withAuth(lazy(() => import("./pages/OwnersPage")));

const StaffPage = withAuth(lazy(() => import("./pages/StaffPage")));

const SubrogationPaymentPage = withAuth(lazy(() => import("./pages/SubrogationPaymentPage")));
const SubrogationPaymentDetailPage = withAuth(lazy(() => import("./pages/SubrogationPaymentPage/Detail")));

// const SubrogationRequestRegisterPage = withAuth(lazy(() => import("./pages/SubrogationRequestRegisterPage")));
const SubrogationRequestRegisterCreate = withAuth(lazy(() => import("./pages/SubrogationRequestRegisterPage/Create")));

// const InclusiveContractApplicationPage = withAuth(lazy(() => import("./pages/InclusiveContractApplication")));
const InclusiveContractApplicationManagementPage = withAuth(
  lazy(() => import("./pages/InclusiveContractApplicationManagement"))
);
const DetailInclusiveContractApplicationManagement = withAuth(
  lazy(() => import("./pages/InclusiveContractApplicationManagement/DetailContractApplication"))
);

const EquipmentGuaranteeContractPage = withAuth(lazy(() => import("./pages/EquipmentGuaranteeContractPage")));

const ItemsPage = withAuth(lazy(() => import("./pages/ItemsPage")));
const ItemsPageCreate = withAuth(lazy(() => import("./pages/ItemsPage/Create")));
const ItemsPageDetail = withAuth(lazy(() => import("./pages/ItemsPage/Detail")));
const DocumentTemplatesPage = withAuth(lazy(() => import("./pages/DocumentTemplatesPage")));
const DocumentTemplatesCreatePage = withAuth(lazy(() => import("./pages/DocumentTemplatesPage/Create")));
const DocumentTemplateDetailPage = withAuth(lazy(() => import("./pages/DocumentTemplatesPage/Detail")));
const CancelContractPage = withAuth(lazy(() => import("./pages/CancelContractPage")));
const CancelContractDetailPage = withAuth(lazy(() => import("./pages/CancelContractPage/Detail")));

const NoticesPage = withAuth(lazy(() => import("./pages/NoticesPage")));
const NoticesPageCreate = withAuth(lazy(() => import("./pages/NoticesPage/Create")));
const NoticeDetailPage = withAuth(lazy(() => import("./pages/NoticesPage/Detail")));
const NotificationDeliveriesPage = withAuth(lazy(() => import("./pages/NotificationDeliveriesPage")));

const BadRequestPage = withAuth(lazy(() => import("./pages/ErrorPage/BadRequest")));
const ForbiddenPage = withAuth(lazy(() => import("./pages/ErrorPage/Forbidden")));
const NotFoundPage = withAuth(lazy(() => import("./pages/ErrorPage/NotFound")));

function Router() {
  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<Spin fullscreen />}>
          <UserProvider>
            <Routes>
              <Route path={Routers.Login} element={<LoginPage />} />
              <Route path={Routers.HealthCheck} element={<HealthCheckPage />} />
              <Route path={Routers.Maintenance} element={<MaintenancePage />} />
              <Route element={<AuthGuard />}>
                <Route path="/" element={<Layout />}>
                  {/* Dashboard */}
                  {/* <Route path={Routers.Dashboard} element={<DashboardPage />} /> */}
                  <Route index element={<Navigate to={Routers.Contracts} state={'contract'} replace />} />
                  <Route element={<PermissionGuard />}>


                    {/* Contracts */}
                    <Route path={Routers.Contracts} element={<ContractsPage />} />
                    <Route path={Routers.ContractRenewals} element={<ContractRenewalsPage />} />
                    <Route path={Routers.ContractDetail} element={<ContractDetailPage />} />

                    {/* Applications */}
                    <Route path={Routers.Applications} element={<ApplicationsPage />} />
                    <Route path={Routers.ApplicationDetail} element={<ApplicationDetailPage />} />

                    {/* Application Intake */}
                    <Route path={Routers.ApplicationIntake} element={<ApplicationIntakePage />} />

                    {/* Affiliates */}
                    <Route path={Routers.Affiliates} element={<AffiliatesPage />} />
                    <Route path={Routers.AffiliateNew} element={<AffiliateFormPage />} />
                    <Route path={Routers.AffiliateDetail} element={<AffiliateDetailPage />} />
                    <Route
                      path={Routers.AffiliateInquiries}
                      element={<Navigate to={`${Routers.AffiliateApplications}?tab=new-affiliate`} replace />}
                    />
                    <Route path={Routers.AffiliateInquiryDetail} element={<AffiliateInquiryDetailPage />} />
                    <Route path={Routers.AffiliateApplications} element={<AffiliateApplicationsPage />} />
                    <Route path={Routers.AffiliateApplicationDetail} element={<AffiliateApplicationDetailPage />} />
                    <Route
                      path={Routers.ShopRegistrationApplies}
                      element={<Navigate to={`${Routers.AffiliateApplications}?tab=shop-addition`} replace />}
                    />
                    <Route
                      path={Routers.ShopRegistrationApplyDetail}
                      element={<ShopRegistrationApplicationDetailPage />}
                    />

                    {/* Variable Cost Registration */}
                    <Route path={Routers.VariableCostRegistration} element={<VariableCostRegistrationPage />} />

                    {/* Variable Cost Applications */}
                    <Route path={Routers.VariableCostApplications} element={<VariableCostApplicationsPage />} />
                    <Route path={Routers.VariableCostApplicationDetail} element={<VariableCostApplicationDetailPage />} />

                    {/* Subrogation Payment */}
                    <Route path={Routers.SubrogationPayment} element={<SubrogationPaymentPage />} />
                    <Route path={Routers.SubrogationPaymentDetailPage} element={<SubrogationPaymentDetailPage />} />

                    {/* Subrogation Request Register */}
                    {/* <Route path={Routers.SubrogationRequestRegister} element={<SubrogationRequestRegisterPage />} /> */}
                    <Route path={Routers.SubrogationRequestRegisterCreate} element={<SubrogationRequestRegisterCreate />} />

                    {/* Delinquents */}
                    <Route path={Routers.Delinquents} element={<DelinquentsPage />} />
                    <Route path={Routers.DelinquentDetail} element={<DelinquentDetailPage />} />
                    <Route path={Routers.DelinquentsPoppo} element={<DelinquentsPoppoPage />} />

                    {/* Equipment Warranty */}
                    {/* <Route path={Routers.EquipmentWarranty} element={<EquipmentWarrantyPage />} /> */}
                    {/* <Route path={Routers.EquipmentWarrantyDetail} element={<EquipmentWarrantyDetailPage />} /> */}
                    <Route path={Routers.EquipmentGuaranteeContract} element={<EquipmentGuaranteeContractPage />} />

                    {/* <Route path="itanji-integration" element={<ItanjiIntegrationPage />} /> */}

                    {/* Customers */}
                    {/* <Route path={Routers.Customers} element={<CustomersPage />} /> */}

                    {/* Inclusive Contract Application */}
                    {/* <Route path={Routers.InclusiveContractApplication} element={<InclusiveContractApplicationPage />} /> */}
                    <Route
                      path={Routers.InclusiveContractApplicationDetail}
                      element={<DetailInclusiveContractApplicationManagement />}
                    />
                    <Route
                      path={Routers.InclusiveContractApplicationManagement}
                      element={<InclusiveContractApplicationManagementPage />}
                    />

                    {/* Initial Billing */}
                    <Route path={Routers.InitialBilling} element={<InitialBillingPage />} />

                    {/* Payment Management */}
                    {/* <Route path={Routers.PaymentManagement} element={<PaymentManagementPage />} /> */}

                    {/* Finance */}
                    <Route path={Routers.Finance} element={<FinancePage />} />
                    <Route path={Routers.Invoices} element={<InvoiceManagementPage />} />

                    {/* Owner Remittance */}
                    <Route path={Routers.OwnerRemittance} element={<OwnerRemittancePage />} />

                    {/* <Route path="communication" element={<CommunicationPage />} /> */}

                    {/* Settings */}
                    <Route path={Routers.Settings} element={<SettingsPage />} />
                    <Route path={Routers.SystemSettings} element={<SystemSettingsPage />} />

                    {/* Buildings */}
                    <Route path={Routers.Buildings} element={<BuildingsPage />} />
                    <Route path="/buildings/legacy" element={<LegacyBuildingsPage />} />
                    <Route path="/buildings/:buildingId" element={<BuildingsPage />} />

                    {/* Owners */}
                    <Route path={Routers.Owners} element={<OwnersPage />} />

                    {/* Staff */}
                    <Route path={Routers.Staff} element={<StaffPage />} />

                    {/* Items */}
                    <Route path={Routers.Items} element={<ItemsPage />} />
                    <Route path={Routers.ItemsCreate} element={<ItemsPageCreate />} />
                    <Route path={Routers.ItemsDetail} element={<ItemsPageDetail />} />
                    <Route path={Routers.DocumentTemplates} element={<DocumentTemplatesPage />} />
                    <Route path={Routers.DocumentTemplatesCreate} element={<DocumentTemplatesCreatePage />} />
                    <Route path={Routers.DocumentTemplateDetail} element={<DocumentTemplateDetailPage />} />

                    {/* Cancel Contracts */}
                    <Route path={Routers.CancelContracts} element={<CancelContractPage />} />
                    <Route path={Routers.CancelContractDetail} element={<CancelContractDetailPage />} />

                    {/* Notices */}
                    <Route path={Routers.Notices} element={<NoticesPage />} />
                    <Route path={Routers.NoticesCreate} element={<NoticesPageCreate />} />
                    <Route path={Routers.NoticeEdit} element={<NoticesPageCreate />} />
                    <Route path={Routers.NoticeDetail} element={<NoticeDetailPage />} />
                    <Route path={Routers.NotificationDeliveries} element={<NotificationDeliveriesPage />} />

                    {/* Errors  */}
                    <Route path={Routers.BadRequest} element={<BadRequestPage />} />
                    <Route path={Routers.Forbidden} element={<ForbiddenPage />} />
                    <Route path={Routers.NotFound} element={<NotFoundPage />} />

                  </Route>
                </Route>
              </Route>

            </Routes>
          </UserProvider>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
